import instance from 'Src/common/utilities/axios_util';
import {
  GET_SERVICES_OFFERED,
  GET_PROGRAM_DETAILS,
  APPLY_FOR_MENTORSHIP_PATH,
  FORM_FIELDS_PATH,
  GET_PREFILL_DATA,
  GET_USER_PROFILE,
  GET_VERIFICATION_STATUS,
  GET_MENTORS_DATA,
  GET_SINGLE_MENTOR_DATA,
  GET_CONNECTION_REPORT,
  GET_FORM_ENTRY,
  SEND_CONNECTION_REQUEST,
  UPDATE_CONNECTION_STATUS,
  GET_CONNECTIONS,
  GET_SINGLE_CONNECTION,
  GET_ONBOARDING_STATUS,
  GET_PROFILE_INFORMATION_FORM,
  MESSAGES_PATH,
  USER_FEEDBACK_API_PATH,
  GET_MENTOR_FILTERS,
  POST_MESSAGES_PATH,
} from '../endpoints';

export const getProgramDetails = () => instance.get(GET_PROGRAM_DETAILS);

export const getServicesOffered = () => instance.get(GET_SERVICES_OFFERED);

export const applyForMentorship = (data, id) =>
  instance.post(`${APPLY_FOR_MENTORSHIP_PATH}${id ? `?profile_id=${id}` : ''}`, data);

export const getFormFields = (id) => instance.get(FORM_FIELDS_PATH.replace('<form_id>', id));

export const getPrefilledData = (id) => instance.get(GET_PREFILL_DATA.replace('/{}', id ? `?profile_id=${id}` : ''));

export const getUserProfile = (id) => instance.get(GET_USER_PROFILE.replace('{}', id));

export const getVerificationStatus = (id) => instance.get(GET_VERIFICATION_STATUS.replace('<id>', id));

export const getMentors = (page, search, data = {}) =>
  instance.post(`${GET_MENTORS_DATA}?page=${page}&search=${search}`, data);

export const getMentorData = (id) => instance.get(GET_SINGLE_MENTOR_DATA.replace('{}', id));

export const getConnectionReport = () => instance.get(GET_CONNECTION_REPORT);

export const getFormEntry = (formId, entryId) =>
  instance.get(GET_FORM_ENTRY.replace('{form_id}', formId).replace('{entry_id}', entryId));

export const sendConnectionRequest = (data) => instance.post(SEND_CONNECTION_REQUEST, data);

export const updateConnectionStatus = (id, data) => instance.patch(UPDATE_CONNECTION_STATUS.replace('{id}', id), data);

export const getConnections = (page) => instance.get(`${GET_CONNECTIONS}?page=${page}`);

export const getSingleConnection = (id) => instance.get(GET_SINGLE_CONNECTION.replace('{id}', id));

export const getOnboardingStatus = () => instance.get(GET_ONBOARDING_STATUS, { hideNotification: true });

export const getProfileInformationForm = () => instance.get(GET_PROFILE_INFORMATION_FORM, { hideNotification: true });

export const getMessages = (id, page) =>
  instance.get(MESSAGES_PATH.replace('{connection_id}', id).replace('{page}', page));

export const postMessage = (id, data) => instance.post(POST_MESSAGES_PATH.replace('{connection_id}', id), data);

export const submitUserFeedback = ({ content_type, object_id, parent_object_id }, data) =>
  instance.post(
    `${USER_FEEDBACK_API_PATH}?content_type=${content_type}&object_id=${object_id}&parent_object_id=${parent_object_id}`,
    data,
  );

export const getFilters = () => instance.get(GET_MENTOR_FILTERS);
